import { Component, HostListener, Inject, inject, PLATFORM_ID, Signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ProductService } from '../../../../shared/service/product.service';
import { CurrencyPipe, isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import { ImgProductSizePipe } from '../../../../core/pipes/img-product-size.pipe';
import { GoogleAnalyticsService } from '@hakimio/ngx-google-analytics';
import { Store } from '@ngxs/store';
import { ProductsState } from '../../../../shared/state/products.state';
import { ProductsAction } from '../../../../shared/state/products.actions';
import { Meta, Title } from '@angular/platform-browser';
import { Socket } from 'ngx-socket-io';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-category-home',
  imports: [CurrencyPipe, NgOptimizedImage, ImgProductSizePipe, RouterLink],
  templateUrl: './category-home.component.html',
  styleUrl: './category-home.component.scss'
})
export class CategoryHomeComponent {
  private readonly gaService = inject(GoogleAnalyticsService);
  platform = inject(PLATFORM_ID);
  product: Signal<any>;
  slug = this.activeRoute.snapshot.params['slug'];
  categoryActive = 0;
  body = {
    where: 'typeToys',
    conditions: '==',
    value: 1,
    limit: 99,
    fieldOrder: 'typeToys',
    orderBy: 'desc',
  };
  listProduct: any;
  size: any;
  // size = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  getScreen(event: any) {
    this.size = event.innerWidth;
  }
  constructor(
    private activeRoute: ActivatedRoute,
    private productService: ProductService,
    private store: Store,
    private _doc: Title,
    private meta: Meta,
    @Inject(DOCUMENT) private document: Document
    // private socket: Socket
  ) {
    this.activeRoute.params.subscribe((res: any) => {
      this.slug = res.slug;
      this.decodeSlug(this.slug);
      this.getProduct();
      this._doc.setTitle(`Etoy Republic - ${res.slug!}`)
      this.meta.updateTag({ name: 'description', content: `Categoria ${res.slug}` });
    });
    this.decodeSlug(this.slug);

    this.product = this.store.selectSignal(ProductsState.getProduct);
  }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platform)) {
      this.document.defaultView?.scrollTo({ top: 0, behavior: 'smooth' });
    }
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.getProduct();
    this.gaService.pageView(`/category/${this.slug}`, {
      title: `Pagina Category Etoy Republic - ${this.slug}`,
    });
    // this.getSocketProducto()
  }
  getProduct() {
    let url = 'stock';
    if (this.slug === 'pre-venta') {
      url = 'news'
    }
    if (this.slug !== 'stock' && this.slug !== 'pre-venta') {
      this.body.value = this.categoryActive;
      url = 'all/0';
    }


    if (this.product()?.items[this.slug] !== undefined && this.product()?.items[this.slug]?.data.length > 0) {

      this.listProduct = this.product()?.items[this.slug];
    } else {


      this.productService.postAllProduct(this.body, url).subscribe((res) => {

        res.data?.forEach((element) => {
          //
          // element?.price_currency!.forEach(price => {
          //
          //   const comision = +price.regular_price! * .036;
          //   const comisionMeses = +price.regular_price! * .0457;
          //
          //   price.regular_price = Math.ceil(comisionMeses + +price.regular_price!);
          // });
        });
        res.data = res?.data?.sort((a, b) => {
          // Priorizar productos con stock >= 1
          if (a.stock >= 1 && b.stock < 1) {
            return -1;
          }
          if (a.stock < 1 && b.stock >= 1) {
            return 1;
          }
          // Si ambos tienen stock o ambos no tienen stock, mantener orden original
          return 0;
        })


        const obj = Object.assign({}, { [this.slug]: res });
        this.store.dispatch(new ProductsAction.Set(obj));

        this.listProduct = res;
        console.log(this.listProduct);
      });
    }
  }
  decodeSlug(slug) {
    switch (slug) {
      case 'artoys':
        this.categoryActive = 1;
        this.body.where = 'typeToys';
        this.body.fieldOrder = 'typeToys';
        break;
      case 'sofubi':
        this.categoryActive = 2;
        this.body.where = 'typeToys';
        this.body.fieldOrder = 'typeToys';
        break;
      case 'gachapon':
        this.categoryActive = 3;
        this.body.where = 'typeToys';
        this.body.fieldOrder = 'typeToys';
        break;
      case 'blindbox':
        this.categoryActive = 4;
        this.body.where = 'typeToys';
        this.body.fieldOrder = 'typeToys';
        break;
      case 'stock':
        // this.categoryActive = 4;
        this.body.where = 'stock';
        this.body.fieldOrder = 'stock';
        this.body.value = 1;
        this.body.conditions = '>=';
        break;
      case 'pre-venta':
        // this.categoryActive = 4;
        this.body.where = 'status';
        this.body.fieldOrder = 'status';
        this.body.value = 2;
        this.body.conditions = '==';
        break;
      default:
        this.body.where = 'category';
        this.body.conditions = '==';
        this.body.fieldOrder = 'category';
        this.body.value = slug;
        this.categoryActive = slug;
        break;
    }
  }

  // getSocketProducto() {
  //   this.socket.fromEvent('reloadProduct').subscribe(res => {
  //     this.store.dispatch(new ProductsAction.Set({}))
  //     this.getProduct()
  //   });
  // }
}
